import axios from '@lib/apiClient'

export default {
  methods: {
    getSurvey(survey_id) {
      return axios
        .get(`/admin/api/surveys/${survey_id}.json`)
        .then((response) => {
          this.survey = response.data.survey
        })
        .catch((e) => {
          this.errors = e
        })
    },
    createSurveyFromUercRequest(uerc_request_id, survey) {
      return axios.post(`/admin/api/uerc_requests/${uerc_request_id}/create_survey.json`, {
        survey: survey,
      })
    },
    updateSurvey() {
      axios
        .patch(`/admin/api/surveys/${this.survey_id}.json`, {
          survey: this.survey,
        })
        .then((response) => {
          this.survey = response.data.survey
          this.$toast('Survey Saved')
        })
    },
    patchRenderableTestimonial(rt) {
      return axios.patch(`/admin/api/renderable_testimonials/${rt.id}.json`, {
        renderable_testimonial: rt,
      })
    },
    getUercRequests() {
      return axios.get('/admin/api/uerc_requests.json')
    },
    getUercRequest(id) {
      return axios.get(`/admin/api/uerc_requests/${id}.json`)
    },
    getSurveyImport(survey_import_id) {
      return axios.get(`/admin/api/survey_imports/${survey_import_id}.json`)
    },
    createSurveyImport(survey_import) {
      return axios.post('/admin/api/survey_imports.json', survey_import, {
        'Content-Type': 'multipart/form-data',
      })
    },
    searchCompanies(term) {
      return axios.get(`/admin/api/companies/search.json?s=${term}`)
    },
  },
}
